import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const getEmployeesBroker = createAsyncThunk(
  "employees/getEmployees",
  async ({ status, page, query = "" }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/broker/employees?status=${status}&page=${page}&query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error fetching employees");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const getEmployerById = createAsyncThunk(
  "employers/getEmployerWithId",
  async (id) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/employer/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Error fetching employer");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const getEmployersWithCode = createAsyncThunk(
  "employers/getEmployersWithCode",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/broker/employers`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Error fetching employers");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const getEmployeeForEmployer = createAsyncThunk(
  "employees/getEmployeeForEmployer",
  async ({ id, status, page, query = "" }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/employer/${id}/employees?status=${status}&page=${page}&query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error fetching employees");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const addEmployerGroup = createAsyncThunk(
  "employers/addEmployerGroup",
  async (data) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/broker/employers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        console.log(response);
        const responseData = await response.json();
        console.log(responseData);
        throw new Error(
          responseData.error || "There was a problem. Please try again later."
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);
